/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ explanation: NonNullable<unknown> }} Special_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "{explanation} transactions are excluded" |
*
* @param {Special_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const special_tps_explanation = /** @type {((inputs: Special_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Special_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.explanation} transactions are excluded`)
});